export default __webpack_public_path__ + "static/media/mahatmaji.62566dbc.png";